import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { signOut } from '../../authService';
import { endViewAsFromTab } from '../../viewAs/viewAsAPI';
import { isViewAs } from '../../viewAs/viewAsSession';

const SignOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // HA-447: in a view-as tab, signing out ends the support session. The cookies are the
    // admin's own session in their other tab and stay as they are.
    if (isViewAs()) {
      void endViewAsFromTab();

      return;
    }
    // HA-445: the API ends the session and clears its cookie. Then to the login page with the
    // signed_out indicator.
    void signOut().then((ok) => {
      if (ok) {
        window.location.href = '/LogIn?reason=signed_out';

        return;
      }
      // The API couldn't be reached, so the session may still be live: say so rather than look
      // signed out (the sign-in page would send a live session straight back in).
      window.alert('Sign-out did not complete. Check your connection and try again.');
      window.location.href = '/Dashboard';
    });
  }, [navigate]);

  return null;
};

export default SignOut;
